import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const bindListDelay: number = getFeature('bind-list-delay') || 5000;
